"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var topic_metric_collector_1 = require("./../../services/metric-collectors/topic-metric-collector");
var require_non_null_1 = require("./../../util/require-non-null");
/**
 * Implementation of {@link TopicMetricCollectorBuilder}.
 */
var TopicMetricCollectorBuilderImpl = /** @class */ (function () {
    function TopicMetricCollectorBuilderImpl() {
        this.exportToPrometheusProp = false;
        this.groupByTopicTypeProp = false;
        this.reset();
    }
    /**
     * @inheritdoc
     */
    TopicMetricCollectorBuilderImpl.prototype.reset = function () {
        this.exportToPrometheusProp = false;
        this.groupByTopicTypeProp = false;
        return this;
    };
    /**
     * @inheritdoc
     */
    TopicMetricCollectorBuilderImpl.prototype.exportToPrometheus = function (exportMetrics) {
        this.exportToPrometheusProp = exportMetrics;
        return this;
    };
    /**
     * @inheritdoc
     */
    TopicMetricCollectorBuilderImpl.prototype.groupByTopicType = function (group) {
        this.groupByTopicTypeProp = group;
        return this;
    };
    /**
     * @inheritdoc
     */
    TopicMetricCollectorBuilderImpl.prototype.create = function (name, topicSelector) {
        return new topic_metric_collector_1.TopicMetricCollectorImpl(require_non_null_1.requireNonNull(name, 'name is null'), this.exportToPrometheusProp, typeof topicSelector === 'string' ? topicSelector : topicSelector.expression, this.groupByTopicTypeProp);
    };
    return TopicMetricCollectorBuilderImpl;
}());
exports.TopicMetricCollectorBuilderImpl = TopicMetricCollectorBuilderImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/metrics/topic-metric-collector-builder.js
// module id = 1200
// module chunks = 1